import React from 'react';
import { Balance } from './components/Balance';
import { UserAvatar } from './components/UserAvatar';
import { Container } from './styles';
export var UserBlock = function (_a) {
    var view = _a.view, openSideMenu = _a.openSideMenu, openDeposit = _a.openDeposit, openWithdraw = _a.openWithdraw, onAccountsClick = _a.onAccountsClick, is2FADisabled = _a.is2FADisabled;
    return (React.createElement(Container, { "data-testid": "user-menu" },
        React.createElement(Balance, { view: view, openDeposit: openDeposit, openWithdraw: openWithdraw, onAccountsClick: onAccountsClick }),
        React.createElement(UserAvatar, { openSideMenu: openSideMenu, menuView: view, warning: is2FADisabled })));
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/UserBlock/index.js
// module id = 1372
// module chunks = 118